var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1284 41.2793H23.6082V24.7933H18.1284V41.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8328 22.5421H20.8685C22.7794 22.5421 23.9687 21.2763 23.9687 19.6943C23.933 18.0765 22.7794 16.8457 20.9049 16.8457C19.0303 16.8457 17.8047 18.0765 17.8047 19.6943C17.8047 21.2763 18.994 22.5421 20.8328 22.5421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.888 41.2793H43.3671V31.8262C43.3671 26.7626 40.6638 24.4064 37.0586 24.4064C34.1513 24.4064 32.8484 26.0042 32.1202 27.1275V24.7933H26.6408C26.7125 26.34 26.6408 41.2793 26.6408 41.2793H32.1202V32.0728C32.1202 31.5801 32.1556 31.0878 32.3005 30.7355C32.6967 29.7512 33.5982 28.7315 35.1119 28.7315C37.0946 28.7315 37.888 30.2432 37.888 32.4597V41.2793Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.970b9146021a542bd509547c39068451.svg";
export { ForwardRef as ReactComponent };